// extracted by mini-css-extract-plugin
module.exports = {"idle":"chrome-ProgressBar__idle--nm52Z","active":"chrome-ProgressBar__active--1BGYK chrome-ProgressBar__idle--nm52Z","loading-anim":"chrome-ProgressBar__loading-anim--rs-ff"};